import React, { useState,  useEffect, useRef} from 'react';
import Logo from './images/logo2.png'
import SandboxLogo from './images/SandboxBadge.dac96828.svg'
import { useLocation } from 'react-router-dom';
import { ENDPOINT} from '../../variaveis';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
function SettingsHeader() {
  const { t, i18n} = useTranslation();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  
    const [hoveredIndex, setHoveredIndex] = 
    useState(null);

    const handleMouseEnter = (index) => {
      setHoveredIndex(index);
    };
  
    const handleMouseLeave = () => {
      setHoveredIndex(null);

    };
  
    const [menuVisible, setMenuVisible] = useState(false);
    const LogoutRef = useRef();
    const buttonRefLogout = useRef(null);
    const toggleMenu = () => {
      setMenuVisible(!menuVisible);
 
    };
  
    const isActiveMenuItem = (menuItem) => {
      // Retorne verdadeiro se o caminho corresponder à página atual
      return window.location.pathname.includes(menuItem);
    };

    useEffect(() => {
      // Obtem os usuários do localStorage
      const loadedUsers = localStorage.getItem('userData');
      if (loadedUsers) {
        setUsers(JSON.parse(loadedUsers));
      }
        
    }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (menuVisible && LogoutRef.current && !LogoutRef.current.contains(event.target) && !buttonRefLogout.current.contains(event.target)) {
          setMenuVisible(false);
          
        }
      };
    
      document.addEventListener('click', handleClickOutside);
    
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, [menuVisible]);

    const handleLogout = async () => {
      console.log('Response OK');
      const currentTime = Math.floor(Date.now() / 1000);
      localStorage.setItem('tokenExpiry', currentTime);
  
      const tokenExpiry = localStorage.getItem('tokenExpiry');
      console.log("TOKEN: ", tokenExpiry)
        const response = await fetch(`${ENDPOINT}/logout`, {
          method: 'PATCH',
          credentials: 'include',
          
        });
    
        console.log('Fetch completed'); 
        
        if (response.ok) {
         
          
           
        }; 
      }
  
    


    
return(<div
    className="z-20 flex h-screen w-min flex-col shadow-lg bg-black-700 fixed"
    data-testid="settings-nav"
  >
     <header className="flex p-3 pb-8">
          <a
            className="inline-block w-fit p-0"
            title="Home"
            aria-label="Home"
            href="/wallet"
          >
            <img src={Logo}></img>
          </a>

      
          
        </header>
    <h2 className="mt-1 py-2 px-6 text-base uppercase text-white font-circular-bold">
      Settings
    </h2>
    <div
      data-testid="scroll-container"
      className="cb-scroll-container with-overflow-mask bottom-mask h-full"
    >
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          height: "100%"
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            overflow: "scroll",
            marginRight: "-17px",
            marginBottom: "-17px"
          }}
        >
          <div className="content">
            <div className="grid w-min grid-flow-row-dense auto-rows-min gap-y-3.5">
              <nav className="cb-sidenav dark" data-testid="sidenav">
               
                  
                  <span className="group-items">
                    <a
                      className={`cb-sidenav-group-item${isActiveMenuItem("settings") ? " active" : ""}`}
                      title="Personal info"
                      href="/settings"
                     
                    >
                      
  <svg style={{position:'absolute', width:'25px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <path
      d='M12.9977 18.3308C12.9977 17.864 13.0777 17.4146 13.2257 16.9971H4.00043C3.60636 16.997 3.21612 17.0745 2.85201 17.2252C2.4879 17.3759 2.15707 17.597 1.87841 17.8756C1.59976 18.1543 1.37876 18.4852 1.22804 18.8493C1.07731 19.2135 0.999825 19.6037 1 19.9979V21.2235C1 21.9863 1.24003 22.7305 1.68143 23.352C3.73772 26.238 7.10354 27.6663 11.6642 27.6663C12.1949 27.6663 12.7083 27.6477 13.2071 27.609C13.0685 27.1978 12.9978 26.7667 12.9977 26.3327V18.3308ZM11.6642 1C12.5398 1 13.4068 1.17248 14.2158 1.50759C15.0247 1.8427 15.7598 2.33388 16.3789 2.95309C16.9981 3.57229 17.4892 4.30739 17.8243 5.11642C18.1593 5.92545 18.3318 6.79257 18.3318 7.66825C18.3318 8.54394 18.1593 9.41106 17.8243 10.2201C17.4892 11.0291 16.9981 11.7642 16.3789 12.3834C15.7598 13.0026 15.0247 13.4938 14.2158 13.8289C13.4068 14.164 12.5398 14.3365 11.6642 14.3365C9.89583 14.3365 8.19989 13.634 6.94947 12.3834C5.69905 11.1329 4.99657 9.43679 4.99657 7.66825C4.99657 5.89972 5.69905 4.20363 6.94947 2.95309C8.19989 1.70255 9.89583 1 11.6642 1ZM14.3312 18.3308C14.3312 17.6234 14.6122 16.9449 15.1124 16.4447C15.6126 15.9445 16.2909 15.6635 16.9983 15.6635H26.333C27.0403 15.6635 27.7187 15.9445 28.2188 16.4447C28.719 16.9449 29 17.6234 29 18.3308V26.3327C29 27.0401 28.719 27.7186 28.2188 28.2188C27.7187 28.719 27.0403 29 26.333 29H16.9983C16.2909 29 15.6126 28.719 15.1124 28.2188C14.6122 27.7186 14.3312 27.0401 14.3312 26.3327V18.3308ZM17.665 19.6644C17.4882 19.6644 17.3186 19.7347 17.1936 19.8598C17.0685 19.9848 16.9983 20.1544 16.9983 20.3313C16.9983 20.5081 17.0685 20.6777 17.1936 20.8028C17.3186 20.9278 17.4882 20.9981 17.665 20.9981H25.6662C25.843 20.9981 26.0126 20.9278 26.1377 20.8028C26.2627 20.6777 26.333 20.5081 26.333 20.3313C26.333 20.1544 26.2627 19.9848 26.1377 19.8598C26.0126 19.7347 25.843 19.6644 25.6662 19.6644H17.665ZM17.665 23.6654C17.4882 23.6654 17.3186 23.7357 17.1936 23.8607C17.0685 23.9858 16.9983 24.1554 16.9983 24.3322C16.9983 24.5091 17.0685 24.6787 17.1936 24.8037C17.3186 24.9288 17.4882 24.999 17.665 24.999H25.6662C25.843 24.999 26.0126 24.9288 26.1377 24.8037C26.2627 24.6787 26.333 24.5091 26.333 24.3322C26.333 24.1554 26.2627 23.9858 26.1377 23.8607C26.0126 23.7357 25.843 23.6654 25.6662 23.6654H17.665Z'
      fill='#00DC84'
    />
  </svg>

                      <span style={{marginLeft:'25px'}} className="inner">{t('profile')}</span>
                    </a>
                  </span>
              
               
               
                  
                  <span className="group-items">
      { /*             <a
                      className={`cb-sidenav-group-item${isActiveMenuItem("banks") ? " active" : ""}${users?.kyc?.level === 0 ? " disabled" : ""}`}
                      title="Bank accounts"
                      href="/banks"
                     
                    >

<svg style={{position:'absolute', width:'25px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M23.4 25V17.5M23.4 17.5L25.8 20M23.4 17.5L21 20'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M27 15C27 10.2863 27 7.92875 25.5936 6.465C24.1884 5 21.9252 5 17.4 5M17.4 25H12.6C8.0748 25 5.8116 25 4.4064 23.535C3 22.0712 3 19.7137 3 15C3 10.2863 3 7.92875 4.4064 6.465C5.8116 5 8.0748 5 12.6 5M12.6 20H7.8M16.2 20H15.6M3 12.5H9M27 12.5H13.8'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
    />
  </svg>


                      <span style={{marginLeft:'25px'}} className="inner">Recipients</span>
        </a>*/}
                    <a
                      className={`cb-sidenav-group-item${isActiveMenuItem("limits") ? " active" : ""}${users?.kyc?.level === 0 ? " disabled" : ""}`}
                      title="limits"
                      href="/limits"
                      
                    >
                       <svg style={{position:'absolute', width:'25px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M27.7273 3H2.27273C1.93518 3 1.61146 3.12643 1.37277 3.35147C1.13409 3.57652 1 3.88174 1 4.2V13.8C1 14.1183 1.13409 14.4235 1.37277 14.6485C1.61146 14.8736 1.93518 15 2.27273 15H6.09091V25.8C6.09091 26.1183 6.225 26.4235 6.46368 26.6485C6.70237 26.8736 7.02609 27 7.36364 27H22.6364C22.9739 27 23.2976 26.8736 23.5363 26.6485C23.775 26.4235 23.9091 26.1183 23.9091 25.8V15H27.7273C28.0648 15 28.3885 14.8736 28.6272 14.6485C28.8659 14.4235 29 14.1183 29 13.8V4.2C29 3.88174 28.8659 3.57652 28.6272 3.35147C28.3885 3.12643 28.0648 3 27.7273 3ZM8.63636 24.6V22.2C9.31146 22.2 9.95891 22.4529 10.4363 22.9029C10.9136 23.353 11.1818 23.9635 11.1818 24.6H8.63636ZM21.3636 24.6H18.8182C18.8182 23.9635 19.0864 23.353 19.5637 22.9029C20.0411 22.4529 20.6885 22.2 21.3636 22.2V24.6ZM21.3636 19.8C20.0134 19.8 18.7186 20.3057 17.7638 21.2059C16.8091 22.1061 16.2727 23.327 16.2727 24.6H13.7273C13.7273 23.327 13.1909 22.1061 12.2362 21.2059C11.2814 20.3057 9.98656 19.8 8.63636 19.8V10.2H21.3636V19.8ZM26.4545 12.6H23.9091V9C23.9091 8.68174 23.775 8.37652 23.5363 8.15147C23.2976 7.92643 22.9739 7.8 22.6364 7.8H7.36364C7.02609 7.8 6.70237 7.92643 6.46368 8.15147C6.225 8.37652 6.09091 8.68174 6.09091 9V12.6H3.54545V5.4H26.4545V12.6ZM15 18.6C15.7552 18.6 16.4934 18.3889 17.1213 17.9933C17.7492 17.5977 18.2386 17.0355 18.5275 16.3777C18.8165 15.7198 18.8921 14.996 18.7448 14.2977C18.5975 13.5993 18.2338 12.9579 17.6999 12.4544C17.1659 11.9509 16.4855 11.6081 15.7449 11.4692C15.0042 11.3303 14.2365 11.4016 13.5388 11.674C12.8412 11.9465 12.2448 12.4079 11.8253 12.9999C11.4058 13.592 11.1818 14.288 11.1818 15C11.1818 15.9548 11.5841 16.8705 12.3001 17.5456C13.0162 18.2207 13.9874 18.6 15 18.6ZM15 13.8C15.2517 13.8 15.4978 13.8704 15.7071 14.0022C15.9164 14.1341 16.0795 14.3215 16.1758 14.5408C16.2722 14.7601 16.2974 15.0013 16.2483 15.2341C16.1992 15.4669 16.0779 15.6807 15.9 15.8485C15.722 16.0164 15.4952 16.1306 15.2483 16.1769C15.0014 16.2232 14.7455 16.1995 14.5129 16.1087C14.2804 16.0178 14.0816 15.864 13.9418 15.6667C13.8019 15.4693 13.7273 15.2373 13.7273 15C13.7273 14.6817 13.8614 14.3765 14.1 14.1515C14.3387 13.9264 14.6625 13.8 15 13.8Z'
      fill='#00DC84'
    />
  </svg>
                      <span style={{marginLeft:'25px'}} className="inner">{t('limits')}</span>
                    </a>
                    
                   
                  </span>
               
            
               {/* <span
                  className="cb-sidenav-group"
                  data-testid="sidenav-group"
                >
                  <h2 className="heading">Security</h2>
                  <span className="group-items">
                   
                    <a
                      className={`cb-sidenav-group-item${isActiveMenuItem("withdraw-delay") ? " active" : ""}`}
                      title="Delayed withdrawals"
                      href="/withdraw-delay"
                      
                    >
                      <span className="inner">Delayed withdrawals</span>
                    </a>
                  </span>
        </span>*/}
              </nav>
            </div>
            <div className="scroll-end" />
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            height: 6,
            transition: "opacity 200ms ease 0s",
            opacity: 0,
            right: 2,
            bottom: 2,
            left: 2,
            borderRadius: 3,
            visibility: "hidden"
          }}
        >
          <div
            style={{
              position: "relative",
              display: "block",
              height: "100%",
              cursor: "pointer",
              borderRadius: "inherit",
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              width: 0
            }}
          />
        </div>
        <div
          className="track-vertical"
          data-testid="track-vertical"
          style={{
            position: "absolute",
            width: 6,
            transition: "opacity 200ms ease 0s",
            opacity: 0,
            visibility: "visible"
          }}
        >
          <div
            className="thumb-vertical"
            style={{
              position: "relative",
              display: "block",
              width: "100%",
              height: 275,
              transform: "translateY(0px)"
            }}
          />
        </div>
      </div>
    </div>
    <nav
      className="cb-sidenav dark h-auto self-end"
      data-testid="settings-nav-bottom"
    >
      <a
        className="cb-sidenav-item"
        id="layout:page.payments.title"
        href="/wallet"
      >
        <span className="inner">
        <svg style={{position:'absolute', width:'30px', height:'30px', background:'none'}} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <path
      d='M6.44444 15H4L15 4L26 15H23.5556M6.44444 15V23.5556C6.44444 24.2039 6.70198 24.8256 7.16041 25.284C7.61883 25.7425 8.24058 26 8.88889 26H21.1111C21.7594 26 22.3812 25.7425 22.8396 25.284C23.298 24.8256 23.5556 24.2039 23.5556 23.5556V15'
      stroke='#00DC84'
      strokeWidth={2.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.3333 26V18.6667C11.3333 18.0184 11.5909 17.3966 12.0493 16.9382C12.5077 16.4798 13.1295 16.2222 13.7778 16.2222H16.2222C16.8705 16.2222 17.4923 16.4798 17.9507 16.9382C18.4091 17.3966 18.6666 18.0184 18.6666 18.6667V26'
      stroke='#00DC84'
      strokeWidth={2.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
          <span className="label" style={{marginLeft:'35px', marginTop:'5px'}}>Home</span>
        </span>
      </a>
      <div
        className="cb-menu cb-sidenav-user-menu dark euclid default"
        data-headlessui-state=""
      >
        <a
          className="button"
          id="headlessui-menu-button-:r1:"
          type="button"
          aria-haspopup="menu"
          aria-expanded="false"
          data-headlessui-state=""
          style={{background:'none', border:'none'}}
          onClick={toggleMenu}
          ref={buttonRefLogout}
        >
            <menu
   className={`cb-menu-options top left transform ${menuVisible ? 'd-block' : 'd-none'}`}
  aria-labelledby="headlessui-menu-button-:ra:"
  id="headlessui-menu-items-:rb:"
  role="menu"
  tabIndex={0}
  data-headlessui-state={menuVisible ? 'open' : 'closed'}
  style={{background:'#008884'}}
  ref={LogoutRef}
>
  <div className="container" role="none">
    
    
   
  <a
          className="cb-menu-item"
          id="headlessui-menu-item-:rd:"
          role="menuitem"
          tabIndex={-1}
          data-headlessui-state=""
          onMouseEnter={() => handleMouseEnter(0)}
      onMouseLeave={handleMouseLeave}
      style={{ backgroundColor: hoveredIndex === 0 ? '#00dc84' : 'transparent' }}
      href='/login'
    
        >
          <div className="item-container default"  onClick={handleLogout}>
            <svg
              width={16}
              height={16}
              viewBox="0 0 18 16"
              fill="none"
              stroke="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              className="cb-icon cb-icon-logout icon pointer-events-none"
              aria-hidden="true"
              data-testid="icon-logout"
              focusable="false"
              role="img"
            >
              <path
                d="M13.167 11.333 16.5 8m0 0-3.333-3.333M16.5 8H4.833m5 3.333v.834a2.5 2.5 0 0 1-2.5 2.5H4a2.5 2.5 0 0 1-2.5-2.5V3.833a2.5 2.5 0 0 1 2.5-2.5h3.333a2.5 2.5 0 0 1 2.5 2.5v.834"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p>Log Out</p>
          </div>
        </a>
  </div>
</menu>

            
          <span className="button-wrapper">
            <span className="inner">
            <span className="cb-avatar sm avatar">
  { users?.fullName?.charAt(0).toUpperCase()+users?.fullName?.charAt(1).toUpperCase()}
</span>
<span className="label">
  {users?.fullName?.split(' ')[0]}
</span>

              <svg
                width={12}
                height={12}
                viewBox="0 0 14 8"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                className="cb-icon cb-icon-chevronup menu-icon pointer-events-none"
                aria-hidden="true"
                role="img"
                focusable="false"
                data-testid="icon-chevronup"
              >
                <path d="M2.145 7.645 7.006 2.93l4.861 4.714a1.275 1.275 0 0 0 1.767 0 1.184 1.184 0 0 0 0-1.713L7.884.355a1.275 1.275 0 0 0-1.767 0L.367 5.932a1.184 1.184 0 0 0 0 1.713c.488.461 1.29.473 1.778 0Z" />
              </svg>
            </span>
          </span>
        </a>
      </div>
    </nav>
  </div>)

    
};
export default SettingsHeader;